export default "__VITE_ASSET__Bz_Oj0m4__"